<template>
    <div>
        <TaskInformation :task-id="taskId" />

        <GeneralInformation :task-id="taskId" />

        <!-- comments panel: shows the workflow's approve/reject/return comments AND lets the
             reviewer add a comment from inside the section (its own Add-Note action). The ribbon's
             separate Add-Notes button stays hidden (:notes="false") so there is one place to add. -->
        <Notes :task-id="taskId" />

        <TaskSurveyForm ref="surveyForm" :task-id="taskId" v-if="taskId" :embed-actions="false" @disabled-change="formDisabled = $event"></TaskSurveyForm>

        <TaskRibbon :task-id="taskId"
                    :notes="false"
                    :complete="taskBits.canComplete"
                    :redirect="taskBits.canRedirect"
                    :rework="taskBits.canRework"
                    :close="taskBits.canClose"
                    :require-comment="isFinalStep"
                    @complete="onComplete"
                    @succeed="succeeded"
                    @rework="onRework">
            <template v-if="!formDisabled" v-slot:action>
                <span class="rb-sep" aria-hidden="true"></span>
                <v-btn class="rb-slot-btn" outlined color="primary" @click="$refs.surveyForm.save()">
                    <v-icon small class="me-1">mdi-content-save-outline</v-icon>{{ $t('Save') }}
                </v-btn>
                <v-btn class="rb-slot-btn rb-slot-btn--quiet" text @click="$refs.surveyForm.preview()">
                    <v-icon small class="me-1">mdi-eye-outline</v-icon>{{ $t('Preview') }}
                </v-btn>
            </template>
        </TaskRibbon>
    </div>
</template>
<script>
    import TasksService from '@/services/TasksService.js'
    import TaskInformation from '@/components/app/task/TaskInformation.vue'
    import Notes from '@/components/app/task/Notes.vue'
    import TaskSurveyForm from '@/components/app/task/survey/TaskSurveyForm.vue'
    import GeneralInformation from '@/components/app/task/dynamic/GeneralInformation.vue'
    import TaskRibbon from '@/components/app/task/TaskRibbon.vue'

    export default {

        components: {
            TaskInformation,
            GeneralInformation,
            Notes,
            TaskSurveyForm,
            TaskRibbon,
        },

        props: {
            taskId: {
                type: Number,
                default: null
            }
        },

        data() {
            return {
                formDisabled: true,
                workProgramsDialog: false,
                taskBits: {
                    activityDefinitionName: null,
                    canRedirect: false,
                    canRework: false,
                    canClose: false,
                    canComplete: false,
                }
            }
        },

        computed: {
            // final step of the survey approval workflow requires a mandatory completion comment
            isFinalStep() {
                return this.taskBits.activityDefinitionName === 'PublishSurvey'
            },
        },

        created() {
            this.getTaskBits()
        },

        methods: {

            getTaskBits() {

                TasksService.getTaskBits(this.taskId).then(res => {
                    if (res.data != null) {
                        this.taskBits = res.data
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                })
            },


            onComplete(proceedCallBackMethod) {
                proceedCallBackMethod(null)
            },

            onRework(proceedCallBackMethod) {
                proceedCallBackMethod(null)
            },

            succeeded(success) {
                this.$emit('completed', success)
            }
        }
    }
</script>
<style scoped>
    .rb-sep { width: 1px; height: 26px; background: #e6ecea; margin: 0 4px; }
    .rb-slot-btn {
        border-radius: 12px !important; font-weight: 700; letter-spacing: 0; text-transform: none;
        height: 40px !important; padding: 0 16px !important;
    }
    .rb-slot-btn--quiet { color: #6b7a77 !important; }
</style>
